import adversarialPic from './adversarial.png';
import aiSchoolPic from './aiSchoolIcon.png';
import cardsPic from './cards.png';
import copyPic from './copy.png';
import kvPic from './kv.png';
import mutualPic from './mutual.png';
import nnliPic from './nnli.png';
import sceneseerPic from './sceneseer.png';
import wienPic from './random_forest.png';
import dstPic from './dst.png';
import vdnPic from './vdn.png';
import confettiPic from './logo_white_letter_vertical_512.png';
import kmdmPic from './kmdm.png';
import policyPic from './policy.png';
import aclWorkshopPic from './aclworkshop.png';
import gluePic from './glue2.jpg';
import primerPic from './ml_primer_img.png';
import observersPic from './observers.png';
import taxesPic from './wheredoestaxmoneygo.png';
import autoplotPic from './autoplot_ex.jpeg';
import randmPic from './randm.png';

const nameToPic = {
  adversarial: adversarialPic,
  aiSchool: aiSchoolPic,
  cards: cardsPic,
  copy: copyPic,
  kv: kvPic,
  mutual: mutualPic,
  nnli: nnliPic,
  sceneseer: sceneseerPic,
  wien: wienPic,
  taxes: taxesPic,
  dst: dstPic,
  vdn: vdnPic,
  confetti: confettiPic,
  kmdm: kmdmPic,
  policy: policyPic,
  nlp4convai: aclWorkshopPic,
  dialoglue: gluePic,
  primer: primerPic,
  observers: observersPic,
  autoplot: autoplotPic,
  randm: randmPic
};

export default nameToPic;



// WEBPACK FOOTER //
// ./src/imgs/index.js